<template>
  <v-container style="max-width: 1280px">
    <v-card
      class="align-center"
      width="500"
      height="100%"
      color="messageBubble"
      elevation="0"
    >
      <div v-html="text"></div>

      <!-- Section Produits -->
      <v-row
        dense
        class="ma-2 mb-4"
        justify="center"
        align="center"
        v-if="message.carousel.values && message.carousel.values.length"
      >
        <v-col v-for="(product, key) in looks" :key="key" cols="12" sm="6">
          <MsgProductCard :message="product" :chat="true" />
        </v-col>
        <v-btn
          fab
          elevation="2"
          absolute
          right
          x-small
          color="cleed_blue"
          style="margin: 0px -30px -10px"
          :disabled="right"
          :light="right"
          @click="next()"
          dark
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          absolute
          left
          color="cleed_blue"
          elevation="2"
          fab
          dark
          x-small
          style="margin: 0px -30px -10px"
          :disabled="left"
          :ligth="left"
          @click="prev()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-row>
      <v-row class="mb-2 text-center" justify="center" align="center" v-else>
        <v-col cols="6" sm="12">
          <v-btn fab large disabled color="white" dark elevation="0">
            <v-icon> mdi-image-off </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" sm="12">
          <span class="white--text"><b>Error url</b> </span>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import utils from "@/utils";
import MsgProductCard from "./Msg_product_card";

export default {
  name: "Chat_caosule",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    MsgProductCard,
  },
  data: () => ({
    looks: [],
    form: 0,
    to: 2,
    model: 0,
    left: false,
    right: false,
    name: "Products",
  }),
  computed: {
    text() {
      let text = this.message.message || this.message.carousel.message || "";
      text = utils.convertMardownToHTML(text);
      text = utils.CleanTextReceived(text);

      return text;
    },
  },
  created() {
    this.from = 0;
    this.to = 2;
    this.diplay_mutiple();
    if (this.from - 2 <= 0) this.left = true;
  },
  methods: {
    diplay_mutiple() {
      this.looks = [];
      for (let i = this.from; i < this.to; i++) {
        const element = this.message.carousel.values[i];
        if (element) this.looks.push(element);
      }
      if (
        this.message.carousel.values &&
        this.message.carousel.values.length <= 2
      )
        this.right = true;
    },
    next() {
      if (
        this.message.carousel.values &&
        this.to + 2 >= this.message.carousel.values.length
      )
        this.right = true;
      this.from = this.to;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.left = false;
    },
    prev() {
      if (this.from - 2 <= 0) this.left = true;
      this.from = this.to - 4;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.right = false;
    },
  },
};
</script>
<style scoped>
.btn-1 {
  margin: 0px 0px 0px -10px !important;
}
.btn-2 {
  margin: 0px 58px -49px;
}
@media only screen and (max-width: 500px) {
  .btn-1 {
    margin: 0px 0px 0px 1px;
  }
  .btn-2 {
    margin: 0px -16px -49px;
  }
}
</style>
